import { apiCall } from '@svb/api-core-component';
import { fallBackRecall, useStore } from '../core/useStore';
import { sideMenu } from './sidemenu';
import {
  fetchCustomApisOrder,
  getCustomSortedApis,
  sortWithAPIWeight,
  filterSubVersionItems,
} from './utilityFunctions';

const browseAPIhandler = () => {
  /* eslint-disable */
  let clientID = process.env.REACT_APP_CLIENT_ID || '';
  let apigeeHost = process.env.REACT_APP_APIGEE_HOST || '';
  const baseUrl = window.location.host;
  const setCatalogdata = (data) => useStore.setState({ catalogItems: data });
  const setDefaultCatalogData = (data) => useStore.setState({ defaultCatalogItems: data });
  const setFaqsdata = (data) => useStore.setState({ faqsItems: data });
  const setDefaultFaqsData = (data) => useStore.setState({ defaultFaqsItems: data });
  const setcustomApiWeightJson = (data) => useStore.setState({ customApiWeightJson: data });
  // Assign default ID and host
  // Assign based on URL
  if (baseUrl.includes('localhost')) {
    clientID = process.env.REACT_APP_LOCAL_CLIENT_ID;
    apigeeHost = process.env.REACT_APP_LOCAL_APIGEE_HOST;
  }
  /* eslint-enable */
  const body = new URLSearchParams();
  body.append('grant_type', 'urn:svb:params:oauth:grant-type:anonymous');
  body.append('client_id', clientID);
  const getOptions = (resource) => {
    return {
      sessionId: 1,
      host: apigeeHost,
      uiRequestorComponent: 'mainCoreComponent',
      resource,
      log: false,
    };
  };

  // Get browse-api response with existing token
  const getCatalogData = async (token) => {
    try {
      return await apiCall({
        ...getOptions('getCatalogItems'),
        extraHeaders: { Authorization: `Bearer ${token}` },
      }).then(async ({ data, status }) => {
        if (status === 200 && status !== 404) {
          let sortedApiItemsData = [];
          let removedMinorSubVersionItems = [];
          if (process.env.REACT_APP_API_ORDER === 'true') {
            //order catalog APIs using constants file from content svc
            const returnedObj = await fetchCustomApisOrder(token)
              .then(async (weightedApisJson) => {
                setcustomApiWeightJson(weightedApisJson);
                sortedApiItemsData = getCustomSortedApis(data.items, weightedApisJson);
                removedMinorSubVersionItems = filterSubVersionItems(sortedApiItemsData);
                setCatalogdata(removedMinorSubVersionItems); //Set the state in the useStore}
                setDefaultCatalogData(removedMinorSubVersionItems);
                const resolvedData = await sideMenu(removedMinorSubVersionItems);
                return resolvedData;
              })
              .catch(async (error) => {
                console.log(
                  'custom order not fetched/error so display as it is using api-weight property if available',
                );
                console.log(error);
                sortedApiItemsData = sortWithAPIWeight(data.items);
                removedMinorSubVersionItems = filterSubVersionItems(sortedApiItemsData);
                setCatalogdata(removedMinorSubVersionItems); //Set the state in the useStore}
                setDefaultCatalogData(removedMinorSubVersionItems);
                const resolvedData = await sideMenu(removedMinorSubVersionItems);
                return resolvedData;
              });

            return returnedObj;
          } else {
            //order catalog APIs using api weight property from browse
            sortedApiItemsData = sortWithAPIWeight(data.items);
            removedMinorSubVersionItems = filterSubVersionItems(sortedApiItemsData);
            setCatalogdata(removedMinorSubVersionItems); //Set the state in the useStore}
            setDefaultCatalogData(removedMinorSubVersionItems);
            const resolvedData = await sideMenu(removedMinorSubVersionItems);
            return resolvedData;
          }
        } else {
          if (
            process.env.NODE_ENV === 'development' &&
            process.env.REACT_APP_APIGEE_CATALOG_FALLBACK === 'true'
          ) {
            //only on local setup while env is set local
            return await fallBackRecall(`/assets/fallbacks/api-catalog.json`).then(async (x) => {
              const items = x.response.items;
              const sortedApiItemsData = sortWithAPIWeight(items);
              const removedMinorSubVersionItems = filterSubVersionItems(sortedApiItemsData);
              setCatalogdata(removedMinorSubVersionItems); //Set the state in the useStore}
              setDefaultCatalogData(removedMinorSubVersionItems);
              const resolvedData = await sideMenu(removedMinorSubVersionItems);
              return resolvedData;
            });
          } else {
            sideMenu([]);
            return [];
          }
        }
      });
    } catch (error) {
      if (
        process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_APIGEE_CATALOG_FALLBACK === 'true'
      ) {
        return await fallBackRecall(`/assets/fallbacks/api-catalog.json`).then(async (x) => {
          const items = x.response.items;
          const sortedApiItemsData = sortWithAPIWeight(items);
          const removedMinorSubVersionItems = filterSubVersionItems(sortedApiItemsData);
          setCatalogdata(removedMinorSubVersionItems); //Set the state in the useStore}
          setDefaultCatalogData(removedMinorSubVersionItems);
          const resolvedData = await sideMenu(removedMinorSubVersionItems);
          return resolvedData;
        });
      } else {
        sideMenu([]);
        return [];
      }
    }
  };
  //  browse-api response with existing token for faqs data
  const getFaqsItems = async (token) => {
    try {
      return await apiCall({
        ...getOptions('getFaqsItems'),
        extraHeaders: { Authorization: `Bearer ${token}`, audience: 'public' },
      }).then(({ data, status }) => {
        if (status === 200 && status !== 404) {
          let faqsItems = data.faqs;
          setFaqsdata(faqsItems); //Set the state in the useStore}
          setDefaultFaqsData(data.faqs);
          return faqsItems;
        } else {
          regenTokenandBrowse();
        }
      });
    } catch (error) {
      return await fallBackRecall(`/faqs/faq-data-sample.json`).then((x) => {
        const items = x.response.faqs;
        setFaqsdata(items); //Set the state in the useStore}
        setDefaultFaqsData(items);
      });
    }
  };
  // Regenerate token, put in localstorage and get browse reposne
  const regenTokenandBrowse = async () => {
    try {
      return await apiCall({ ...getOptions('postAnonymousAccessToken'), body }).then(({ data }) => {
        if (data.access_token) {
          localStorage.setItem('token', data?.access_token);
          return data.access_token;
        } else {
          console.log('failed to generate');
        }
      });
    } catch (error) {
      if (
        process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_APIGEE_CATALOG_FALLBACK === 'true'
      ) {
        console.log('Mocking token');
        const fallback = 'mockingkey123321@!@@!@!';
        localStorage.setItem('token', fallback);
        return fallBackRecall(`/assets/fallbacks/api-catalog.json`).then(async (x) => {
          const sortedApiItemsData = sortWithAPIWeight(x.response.items);
          const removedMinorSubVersionItems = filterSubVersionItems(sortedApiItemsData);
          setCatalogdata(removedMinorSubVersionItems); //Set the state in the useStore}
          setDefaultCatalogData(removedMinorSubVersionItems);
          const resolvedData = await sideMenu(removedMinorSubVersionItems);
          return resolvedData;
        });
      } else {
        sideMenu([]);
        return [];
      }
    }
  };
  return {
    getCatalogData,
    regenTokenandBrowse,
    getFaqsItems,
  };
};

export { browseAPIhandler };
